import styles from "./DashboardPage.module.css";
import { ReactComponent as ChartIcon } from "../../assets/images/Chart.svg";
import { useDispatch, useSelector } from "react-redux";
import { setHeader } from "../../reduxSlices/headerSlice";
import {
  CLIENT_ADMIN_ROLE_ID,
  USER_ROLE_ID,
  VF_ADMIN_ROLE_ID,
  annualGiving,
  appealCategories,
  channelCategories,
  fundPurpose,
  programCategories,
} from "../../constants/constant";
import ReportPage from "../reportPage/ReportPage";
import DisclaimerDialog from "../../components/dialog/DisclaimerDialog";
import React, { useEffect, useState } from "react";
import DropdownButton from "../../components/dropdown/DropdownButton";
import { removeSlashesWithoutSpace } from "../../helpers/helper";
import { useNavigate } from "react-router-dom";
import { getUserLogin } from "../../reduxSlices/userSlice";

const DashboardPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const currentUser = useSelector((state) => state?.user?.currentUser?.data);
  const userEmailId = currentUser?.emailId;
  const userRole = useSelector((state) => state?.user?.userRoleId);
  const isVfAdmin = userRole?.includes(VF_ADMIN_ROLE_ID);
  const isClientAdmin = userRole?.includes(CLIENT_ADMIN_ROLE_ID);
  const isUser = userRole?.includes(USER_ROLE_ID);
  const searchParams = localStorage.getItem("searchParams");
  const alertData = currentUser?.alertDetails;
  const userName = currentUser?.givenName || "";

  const [selectedIndex, setSelectedIndex] = useState(null);

  const showAlert = localStorage.getItem("showAlert");
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
    localStorage.setItem("showAlert", false);
  };

  useEffect(() => {
    dispatch(
      setHeader({
        page: "dashboard",
        title: `${currentUser?.givenName || ""}`,
        subTitle:
          searchParams === "/admin"
            ? "You can see platform analytics here soon, meanwhile you can manage users or check the reports"
            : "Let’s visualise for " + `${currentUser?.organization?.organizationName || ""}`,
      })
    );
  }, [currentUser]);

  useEffect(() => {
    const fetchUserLogin = async () => {
      const obj = {
        email: userEmailId,
      };
      try{
        await dispatch(getUserLogin(obj));
      }
      catch(error){
        console.error("Error fetching user data:", error);
        navigate("/home");
      }
    };
    if(!currentUser)
      fetchUserLogin();
  }, []);

  const handleListItemClick = (data, index) => {
    const { transType, organization } = data;
    const { transalationId } = data?.translation;
    setSelectedIndex(index);

    const selectedTranslation =
      transalationId === 1
        ? channelCategories
        : transalationId === 3
        ? appealCategories
        : transalationId === 2
        ? programCategories
        : transalationId === 18
        ? annualGiving
        : fundPurpose;

    const selectedCategory = selectedTranslation?.find(
      (item) => item?.transType === transType
    );

    let item = {
      ...selectedCategory,
      mainTitle:
        transalationId === 3
          ? "Appeal Category"
          : transalationId === 7
          ? "Philanthropic Funds"
          : selectedCategory?.mainTitle,
      transType:
        transalationId === 3 &&
        selectedCategory?.title === "Custom Fields Categories"
          ? "opt3"
          : selectedCategory?.transType,
    };
    localStorage.setItem("transalationId", transalationId);
    localStorage.setItem("transType", item?.transType);
    localStorage.setItem("page", removeSlashesWithoutSpace(item?.navigate));
    localStorage.setItem("mainTitle", item?.mainTitle);
    localStorage.setItem("title", item?.title);
    localStorage.setItem("subTitle", item?.subTitle);
    localStorage.setItem("selectedOrg", JSON.stringify(organization));
    if (item?.navigate) {
      navigate(item?.navigate);
    }
  };

  useEffect(() => {
    if (showAlert === "true" && searchParams === "/" && alertData?.length > 0) {
      const timeoutId = setTimeout(() => {
        setOpen(true);
      }, 1000);

      return () => {
        clearTimeout(timeoutId);
      };
    }
  }, []);

  return (
    <>
      {(isUser || isClientAdmin) && searchParams === "/" && <ReportPage />}
      {(isClientAdmin || isVfAdmin) && searchParams === "/admin" && (
        <>
          {alertData?.length > 0 && (
            <div className={styles.alertBox}>
              <div className={styles.alertHeader}>
                <span className={styles.alertIcon}></span>
                <span className={styles.alertTitle}>Action Required</span>
              </div>
              <div className={styles.alertContent}>
                <div className={styles.alertMessage}>
                  You have new changes which need your attention. Please take
                  the action accordingly.
                </div>
                <div className={styles.alertActions}>
                  <DropdownButton
                    alertData={alertData}
                    handleListItemClick={handleListItemClick}
                    selectedIndex={selectedIndex}
                  />
                </div>
              </div>
            </div>
          )}
          <div
            className={styles.centerContent}
            style={{ height: alertData?.length > 0 ? "51vh" : "72vh" }}
          >
            <div className={styles.chartIcon2}>
              <ChartIcon />
            </div>
            <div className={styles.thisIsA1}>
              This is a system dashboard, we will brainstorm and show some
              analytics here..
            </div>
          </div>
        </>
      )}
      <DisclaimerDialog
        open={open}
        setOpen={setOpen}
        handleDone={handleClose}
        onClose={false}
        title="ALERT"
        userName={userName}
        subTitle="Some settings in your RE NXT environment have been changed, hence the reports you are seeing might be out of date. This requires your organisation’s admin to refresh configuration settings within Visualise. Please reach out to them for more information. You will stop seeing this message once your admin has taken the required action."
        rightButtonText="Ok"
      />
    </>
  );
};

export default DashboardPage;
